import React, { Fragment } from 'react'
import DefaultText from 'ui/Text'
import Box from 'ui/Box'
import styled from 'styled-components'
import { COLORS } from 'themes'
import { formatDate } from 'utils/datetime'

const StyledBox = styled(Box)`
    margin: 10px 0 0;
`

const Text = styled(DefaultText)`
    color: ${COLORS.lightGrey};
    padding: 0;
`

const Ul = styled(Text.withComponent('ul'))`
    padding: 0 0 0 15px;
    margin: 0;
`

const Li = styled.li`
    font-size: 14px;
`

const StyledLink = styled.a`
    color: ${COLORS.primary};
    text-decoration: none;
`

const CurrentlyExcluded = ({ exclusionTime, permanent = false }) => {
    const dateTime = formatDate(exclusionTime)

    return (
        <Fragment>
            {exclusionTime && (
                <StyledBox>
                    <Text>
                        Din konto er nu lukket til: <strong>{dateTime}</strong>
                    </Text>
                </StyledBox>
            )}
            <StyledBox>
                <Text>
                    Du har valgt at selvudelukke dig fra din konto.{' '}
                    {permanent && (
                        <strong>
                            Din eventuelle balance vil blive udbetalt automatisk
                            til din Nemkonto.
                            <br />
                        </strong>
                    )}{' '}
                    Skulle du have spørgsmål, kan du kontakte vores support. Har
                    du spilleproblemer, eller er i tvivl om du har
                    spilleproblemer så kan du henvende dig til{' '}
                    <strong>Center for ludomani</strong> på telefon:{' '}
                    <StyledLink href="tel:70-11-18-10">70 11 18 10</StyledLink>{' '}
                    eller e-mail på{' '}
                    <StyledLink href="mailto:info@ludomani.dk">
                        info@ludomani.dk
                    </StyledLink>
                    . Du kan læse mere på om ludomani på{' '}
                    <StyledLink href="https://ludomani.dk/" target="_blank">
                        ludomani.dk
                    </StyledLink>{' '}
                    hvor du også kan teste dig selv for ludomani. Du kan også
                    besøge Center for Ludomani på følge adresser:
                </Text>
            </StyledBox>

            <Ul>
                <Li>
                    Center for ludomani i København Nørregade 28D, st. 1165
                    København K
                </Li>
                <Li>Center for ludomani i Odense Østergade 42 5000 Odense</Li>
                <Li>
                    Center for ludomani i Århus Gammel Munkegade 6D 8000 Århus C
                </Li>
            </Ul>

            <StyledBox>
                <Text>
                    Du kan finde flere informationer omkring ludomanicentre her,{' '}
                    <StyledLink
                        href="https://www.spillemyndigheden.dk/gratis-behandling-af-spilafhængighed-ludomani"
                        target="_blank"
                    >
                        Gratis behandling af spilafhængighed (ludomani) |
                        Spillemyndigheden
                    </StyledLink>
                </Text>
            </StyledBox>
        </Fragment>
    )
}

export default CurrentlyExcluded
